import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PrivateRoute from "./Routes/PrivateRoute";

import Layout from "./Routes/Layout";
import Login from "./Identity/Login";
import Registration from "./Identity/Registration";
import Forgot from "./Identity/Forgot";
import ResetPassword from "./Identity/ResetPassword";
import About from './External/About';
import Contact from './External/Contact';
import PrivacyPolicy from './External/PrivacyPolicy';
import TermsofService from './External/TermsofService';
import PaymentSecurity from './External/PaymentSecurity';
import RejectFlightApproval from './Approval/Flight/RejectApproval';
import AcceptFlightApproval from './Approval/Flight/AcceptApproval';
import RejectHotelApproval from './Approval/Hotel/RejectApproval';
import AcceptHotelApproval from './Approval/Hotel/AcceptApproval';
import RejectBusApproval from './Approval/Bus/RejectApproval';
import AcceptBusApproval from './Approval/Bus/AcceptApproval';
import AcceptInsuranceApproval from './Approval/Insurance/AcceptApproval';
import RejectInsuranceApproval from './Approval/Insurance/RejectApproval';
import PayNBook from './PaymentLink/PayNBook';

import PrintInvoice from './Reservations/Bus/PrintInvoice';
import PrintTicket from './Reservations/Bus/BusPrintTicket';

import FlightPrintInvoice from './Reservations/Flight/PrintInvoice';
import FlightPrintTicket from './Reservations/Flight/PrintTicket';

import HotelPrintInvoice from './Reservations/Hotel/PrintInvoice';
import HotelPrintTicket from './Reservations/Hotel/HotelPrintTicket';

import InsurancePrintInvoice from './Reservations/Insurance/InsPrintInvoice';

function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* PUBLIC ROUTES */}
        <Route path="/login" element={<Login />} />
        <Route path="/registration" element={<Registration />} />
        <Route path="/forgot-password" element={<Forgot />} />
        <Route path="/ResetPassword" element={<ResetPassword />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsofService />} />
        <Route path="/payment-security" element={<PaymentSecurity />} />

        <Route path="/approval/flight/rejectApproval" element={<RejectFlightApproval />} />
        <Route path="/approval/flight/acceptApproval" element={<AcceptFlightApproval />} />
        <Route path="/approval/hotel/rejectApproval" element={<RejectHotelApproval />} />
        <Route path="/approval/hotel/acceptApproval" element={<AcceptHotelApproval />} />
        <Route path="/approval/bus/rejectBusApproval" element={<RejectBusApproval />} />
        <Route path="/approval/bus/acceptBusApproval" element={<AcceptBusApproval />} />
        <Route path="/approval/insurance/acceptInsuranceApproval" element={<AcceptInsuranceApproval />} />
        <Route path="/approval/insurance/rejectInsuranceApproval" element={<RejectInsuranceApproval />} />

        <Route path="/payment/paynbook" element={<PayNBook />} />

        <Route path="/reservations/bus/invoice" element={<PrintInvoice />} />
        <Route path="/reservations/bus/printTicket" element={<PrintTicket />} />

        <Route path="/reservations/flight/invoice" element={<FlightPrintInvoice />} />
        <Route path="/reservations/flight/printFlightTicket" element={<FlightPrintTicket />} />

        <Route path="/reservations/hotel/Invoice" element={<HotelPrintInvoice />} />
        <Route path="/reservations/hotel/Ticket" element={<HotelPrintTicket />} />

        <Route path="/reservations/insurance/Invoice" element={<InsurancePrintInvoice />} />

        {/* PROTECTED ROUTES */}
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        />

      </Routes>
    </BrowserRouter>
  );
}

export default App;


